import { store } from '../../store/store';
import { updateGenres as updateGenresAction } from '../../store/slices/genres.slice';
import { IGenre } from '../../types/interfaces/genre';

function updateGenres(value: IGenre[]) {
  store.dispatch(updateGenresAction(value));
}

export default updateGenres;
